(function () {
  "use strict";

  if (window.StoreOperatorProductExperience) return;
  window.StoreOperatorProductExperience = true;

  var reducedMotion = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  function parseVariants(root) {
    var script = root.querySelector("[data-so-product-variants]");
    if (!script) return [];
    try {
      return JSON.parse(script.textContent || "[]");
    } catch (error) {
      return [];
    }
  }

  function shopperStock(variant) {
    if (!variant || !variant.available) {
      return { label: "Out of stock", state: "out", guarantee: "Availability update", detail: "This option is currently unavailable." };
    }
    if (!variant.managed || typeof variant.quantity !== "number") {
      return { label: "In stock", state: "in", guaranteed: true, guarantee: "In-stock guarantee", detail: "Verified available and ready to order." };
    }
    if (variant.quantity >= 100) {
      return { label: "100+ in stock", state: "in", guaranteed: true, guarantee: "In-stock guarantee", detail: "Verified available and ready to order." };
    }
    if (variant.quantity > 0) {
      return {
        label: variant.quantity + " in stock",
        state: variant.quantity <= 5 ? "low" : "in",
        guaranteed: true,
        guarantee: "In-stock guarantee",
        detail: "Verified available and ready to order."
      };
    }
    if (variant.continueSelling) {
      return { label: "Available", state: "low", guaranteed: false, guarantee: "Available to order", detail: "Availability is confirmed during checkout." };
    }
    return { label: "Out of stock", state: "out", guaranteed: false, guarantee: "Availability update", detail: "This option is currently unavailable." };
  }

  function selectedVariantId(details) {
    var select = details.querySelector("[data-variants]");
    if (select && select.value && select.value !== "not-selected") return String(select.value);
    var selection = details.querySelector("[data-variant-selection]");
    var attr = selection && selection.getAttribute("variant");
    return attr && attr !== "not-selected" ? String(attr) : "";
  }

  function updateExperience(root) {
    var details = root.closest("[data-product-details]") || document;
    var variants = parseVariants(root);
    var id = selectedVariantId(details) || String(root.getAttribute("data-initial-variant-id") || "");
    var variant = variants.find(function (item) { return String(item.id) === id; }) || variants[0];
    var state = shopperStock(variant);
    var stock = root.querySelector("[data-so-stock]");
    var guaranteeBadge = root.querySelector("[data-so-guarantee-badge]");
    var guaranteeTitle = root.querySelector("[data-so-guarantee-title]");
    var guaranteeDetail = root.querySelector("[data-so-guarantee-detail]");
    if (stock) {
      stock.textContent = state.label;
      stock.setAttribute("data-stock-state", state.state);
      stock.setAttribute("aria-label", "Selected option availability: " + state.label);
    }
    if (guaranteeBadge) guaranteeBadge.hidden = state.guaranteed !== true;
    if (guaranteeTitle) guaranteeTitle.textContent = state.guarantee;
    if (guaranteeDetail) guaranteeDetail.textContent = state.detail;
  }

  function initProduct(root) {
    if (root.getAttribute("data-so-ready") === "true") return;
    root.setAttribute("data-so-ready", "true");
    var details = root.closest("[data-product-details]");
    if (!details) return;
    details.classList.add("so-product-experience-ready");
    updateExperience(root);

    details.addEventListener("change", function (event) {
      if (event.target && (event.target.matches("[data-variants]") || event.target.closest("[data-options-selection]"))) {
        window.requestAnimationFrame(function () { updateExperience(root); });
      }
    });

    var selection = details.querySelector("[data-variant-selection]");
    if (selection && window.MutationObserver) {
      new MutationObserver(function (records) {
        if (records.some(function (record) { return record.attributeName === "variant"; })) updateExperience(root);
      }).observe(selection, { attributes: true, attributeFilter: ["variant"] });
    }

  }

  function carouselItems(track) {
    return Array.prototype.filter.call(track.children, function (item) {
      return !item.hasAttribute("data-so-carousel-controls");
    });
  }

  function enhanceTrack(track, label, isSizeTrack) {
    if (!track || track.getAttribute("data-so-carousel-ready") === "true") return;
    var items = carouselItems(track);
    if (items.length < 2) return;
    track.setAttribute("data-so-carousel-ready", "true");
    track.classList.add("so-carousel-track");
    if (isSizeTrack) track.setAttribute("data-so-size-track", "");

    var shell = track.parentElement;
    if (!shell) return;
    shell.classList.add("so-carousel-shell");

    var controls = document.createElement("div");
    controls.className = "so-carousel-controls";
    controls.setAttribute("data-so-carousel-controls", "");
    controls.innerHTML =
      '<button type="button" class="so-carousel-button" data-so-carousel-prev aria-label="Previous ' + label + '">&#8249;</button>' +
      '<button type="button" class="so-carousel-button" data-so-carousel-next aria-label="Next ' + label + '">&#8250;</button>';
    shell.insertBefore(controls, track);

    var index = 0;
    var pausedUntil = 0;
    var hovered = false;

    function move(step, userInitiated) {
      items = carouselItems(track);
      if (!items.length) return;
      index = (index + step + items.length) % items.length;
      // Never use scrollIntoView here: even with block "nearest", browsers
      // can scroll the document vertically when an auto-advancing carousel
      // item sits below the fold. Move only this horizontal track instead.
      var targetLeft = Math.max(0, items[index].offsetLeft - track.offsetLeft);
      if (typeof track.scrollTo === "function") {
        track.scrollTo({
          left: targetLeft,
          behavior: reducedMotion ? "auto" : "smooth"
        });
      } else {
        track.scrollLeft = targetLeft;
      }
      if (userInitiated) pausedUntil = Date.now() + 10000;
    }

    controls.querySelector("[data-so-carousel-prev]").addEventListener("click", function () { move(-1, true); });
    controls.querySelector("[data-so-carousel-next]").addEventListener("click", function () { move(1, true); });
    shell.addEventListener("pointerenter", function () { hovered = true; });
    shell.addEventListener("pointerleave", function () { hovered = false; });
    shell.addEventListener("focusin", function () { hovered = true; });
    shell.addEventListener("focusout", function () { hovered = false; });
    track.addEventListener("pointerdown", function () { pausedUntil = Date.now() + 10000; }, { passive: true });
    track.addEventListener("touchstart", function () { pausedUntil = Date.now() + 10000; }, { passive: true });

    if (!reducedMotion) {
      window.setInterval(function () {
        if (document.hidden || hovered || Date.now() < pausedUntil) return;
        move(1, false);
      }, 5500);
    }
  }

  function initCarousels() {
    document.querySelectorAll("[data-product-recommendations] [data-product-row], .product-recommendations--container [data-product-row]").forEach(function (track) {
      var heading = track.closest("[data-product-recommendations], .product-recommendations--container");
      var title = heading && heading.querySelector(".product-recommendations--title");
      if (title && /you may also like/i.test(title.textContent || "")) title.textContent = "Similar items";
      enhanceTrack(track, "similar items", false);
    });

    document.querySelectorAll("[data-similar-sizes], [class*='similar-size'], [id*='similar-size'], .t4s-sizes-list").forEach(function (track) {
      enhanceTrack(track, "similar sizes", true);
    });

    document.querySelectorAll(".t4s-swatch__list").forEach(function (track) {
      var scope = track.closest("section, [class*='size'], [data-product-sizes]");
      if (scope && /similar sizes|other sizes|shop by size/i.test(scope.textContent || "")) {
        enhanceTrack(track, "similar sizes", true);
      }
    });
  }

  function init() {
    document.querySelectorAll("[data-so-product-experience]").forEach(initProduct);
    initCarousels();
  }

  var queued = false;
  function queueInit() {
    if (queued) return;
    queued = true;
    window.requestAnimationFrame(function () {
      queued = false;
      init();
    });
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init);
  else init();

  if (window.MutationObserver) {
    new MutationObserver(queueInit).observe(document.documentElement, { childList: true, subtree: true });
  }
})();
